import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import {BasePureComponent} from './BaseComponent';
import * as Dati from '../Dati';
import {Trad, BottoneAPI} from '../components/';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import {CampoData, CampoNumero} from '../components/';
import * as moment from 'moment';

export class BasePureDeroga<P = {}, S = {}> extends BasePureComponent<P, S> {
    protected GetValore(elemento: string): string {
        return elemento.split("-")[0];
    }

    protected GetTipo(elemento: string): string {
        return elemento.split("-")[1];
    }

    protected GetId(elemento: string): string {
        //return "Deroga_" + this.GetValore(elemento);
        return this.GetValore(elemento);
    }

    protected Campo(elemento: string, ListaValori: Dati.Dictionary<any>): any {
        let id: string = elemento;
        let etichetta: string = this.GetValore(elemento);
        let tipo: string = this.GetTipo(elemento);
        let valore = <div></div>;
        switch (tipo) {
            case "Intero":
                valore = <div></div>;
                break;
            case "Testo":
            case "Stringa":
                valore = <textarea className="form-control" value={ListaValori[id]}
                                   name={"ListaValori[" + id + "]"}
                                   onChange={(e) => this.OnChange(e)} rows={4}/>;
                break;
            case "Importo":
                valore = <CampoNumero Id={"ListaValori[" + id + "]"} Valore={ListaValori[id]}
                                      OnChange={(e) => this.OnChange(e)}
                                      Name={"ListaValori[" + id + "]"}
                                      CSS="form-control kt-input" Icona="la la-money"/>;
                break;
            case "Tipo":
                valore = <div></div>;
                break;
            case "Percentuale":
                valore = <CampoNumero Id={"ListaValori[" + id + "]"} Valore={ListaValori[id]}
                                      OnChange={(e) => this.OnChange(e)}
                                      Name={"ListaValori[" + id + "]"}
                                      CSS="form-control kt-input" Precisione={3}
                                      Icona="fa fa-percentage"/>;
                break;
            case "Data":
                valore =
                    <CampoData ValoreInArrivo={false} Name={"ListaValori[" + id + "]"}
                               Id={"ListaValori[" + id + "]"}
                               OnChange={(e) => this.OnChange(e)} Valore={ListaValori[id]}/>;
                break;
            default:
                valore = <div></div>;
                break;
        }

        return this.Decora(etichetta, valore);
    }

    protected OnChangeDeroga(e: React.FormEvent<any> | string, id: string, ListaValori: Dati.TListaParametriDeroga) {
        ListaValori[id].Valore = (e as React.FormEvent<any>).currentTarget.value;
        this.forceUpdate();
    }

    protected CampoNew(etichetta: string, tipo: string, ListaValori: Dati.TListaParametriDeroga): any {
        let id: string = etichetta;//+'-'+tipo;
        let valore = <div></div>;
        if (ListaValori[id] == undefined)
            ListaValori[id] = new Dati.CTipoCampoDeroga();
        switch (tipo) {
            case "Intero":
                valore = <div></div>;
                break;
            case "Testo":
            case "Stringa":
                valore =
                    <textarea className="form-control" value={ListaValori[id].Valore}
                              name={"ListaValori[" + id + "]"}
                              onChange={(e) => this.OnChangeDeroga(e, id, ListaValori)} rows={4}/>;
                break;
            case "Importo":
                valore = <CampoNumero Id={"ListaValori[" + id + "]"}
                                      Valore={Number(ListaValori[id].Valore)}
                                      OnChange={(e) => this.OnChangeDeroga(e, id, ListaValori)}
                                      Name={"ListaValori[" + id + "]"} CSS="form-control kt-input"
                                      Icona="la la-money"/>;
                break;
            case "Tipo":
                valore = <div></div>;
                break;
            case "Percentuale":
                valore = <CampoNumero Id={"ListaValori[" + id + "]"}
                                      Valore={Number(ListaValori[id].Valore)}
                                      OnChange={(e) => this.OnChangeDeroga(e, id, ListaValori)}
                                      Name={"ListaValori[" + id + "]"} CSS="form-control kt-input"
                                      Precisione={3}
                                      Icona="fa fa-percentage"/>;
                break;
            case "Data":
                valore =
                    <CampoData ValoreInArrivo={false} Name={"ListaValori[" + id + "]"}
                               Id={"ListaValori[" + id + "]"}
                               OnChange={(e) => this.OnChangeDeroga(e, id, ListaValori)}
                               Valore={ListaValori[id].Valore}/>;
                break;
            default:
                valore = <div></div>;
                break;
        }
        return this.Decora(etichetta, valore);
    }

    protected Decora(etichetta: string, elemento: any): any {
        return <div className="form-group kt-form login-form__group row" key={etichetta}>
            <div className="col-lg-12">
                <label>
                    {Trad.Trad(etichetta)}
                    <span></span>
                </label>
                <div className="kt-input-icon kt-input-icon--right">
                    {elemento}
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/BaseDeroga.tsx